import * as React from "react";
import { withRouter } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton/";
import EditIcon from "@material-ui/icons/EditTwoTone";

type Props = {
  history: any;
  statusMessage: any;
};

class ApplicationStatusMessageEditButton extends React.Component<Props, any> {
  navigateToEdit = (statusMessage) => {
    this.props.history.push({
      pathname: `/snapscan/ops/application_status_messages/${statusMessage.id}/edit`,
      state: {
        id: statusMessage.id,
        category: statusMessage.category,
        level: statusMessage.level,
        messageBody: statusMessage.message_body,
      },
    });
  };

  render() {
    return (
      <IconButton
        key="edit"
        color="primary"
        onClick={() => this.navigateToEdit(this.props.statusMessage)}
      >
        <EditIcon />
      </IconButton>
    );
  }
}

export default withRouter(ApplicationStatusMessageEditButton);
